import {C240DeviceStatusConstants} from "../redux_constants/c240_device_status.constant";
import { delay, call} from 'redux-saga/effects'
import {message} from "antd";
import cookie from "react-cookies";
import {isNull} from "../utils/utils";
import {get_response} from "../helper/request";


function* pollStatus(dispatch, goToFirstEmptySlotHandler) {
    while (cookie.load('token')) {
        try {
            yield call(() => dispatch(getC240Status(goToFirstEmptySlotHandler)));
            yield delay(4000);
        } catch (err) {
            console.log(err);
        }
    }
}

export const watchC240DeviceStatus = function* (dispatch, goToFirstEmptySlotHandler) {
    while (cookie.load('token')) {
        yield call(pollStatus, dispatch, goToFirstEmptySlotHandler);
    }
}

function* pollScannerState(dispatch) {
    while (cookie.load('token')) {
        yield call(() => dispatch(getScannerState()));
        try {
            yield delay(4000);
        } catch (err) {
            console.log(err);
        }
    }
}

export const watchC240ScannerStateUpdate = function* (dispatch) {
    while (cookie.load('token')) {
        yield call(pollScannerState, dispatch);
    }
}

function* pollPersistedStateStatus(dispatch) {
    while (cookie.load('token')) {
        try {
            yield call(() => {
                return dispatch(getStatusOfPersistedState());
            });
            yield delay(40000);
        } catch (err) {
            console.log(err);
        }
    }
}

export const watchPersistedStateStatus = function* (dispatch) {
    while (cookie.load('token')) {
        yield call(pollPersistedStateStatus, dispatch);
    }
}

function* pollMachineStatusBar(dispatch, callback) {
    while (cookie.load('token')) {
        try {
            yield call(() => {
                return dispatch(getMachineStatus(callback));
            });
            yield delay(4000);
        } catch (err) {
            console.log(err);
        }
    }
}

export const watchPollMachineStatusBar = function* (dispatch, callback) {
    while (cookie.load('token')) {
        yield call(pollMachineStatusBar, dispatch, callback);
    }
}

export const updateC240ServerState = (server_up) => ({
    type: C240DeviceStatusConstants.UPDATE_SERVER_STATE,
    server_up: server_up
})

export const updateC240ServerData = (data) => ({
    type: C240DeviceStatusConstants.UPDATE_DEVICE_STATUS_DATA,
    data: data
})

export const updateScannerState = (scannerState) => ({
    type: C240DeviceStatusConstants.UPDATE_SCANNER_STATE,
    scannerState: scannerState
})

export const updateQueueState = (queueState) => ({
    type: C240DeviceStatusConstants.UPDATE_QUEUE_STATE,
    queueState: queueState
})

export const updateMachineStatus = (machineStatus) => ({
    type: C240DeviceStatusConstants.UPDATE_MACHINE_STATUS_BAR,
    machineStatus: machineStatus
})

export const getC240Status = (goToFirstEmptySlotHandler, callback=null) => (dispatch) => {
    let url = `/server/scano/1/api~hts~status/`;
    get_response(url)
        .then(response => {
            if (response.status !== 200) {
                message.error("Error");
                dispatch(updateC240ServerState(false));
            } else {
                console.debug("res-data", response.data)
                dispatch(updateC240ServerState(true));
                dispatch(updateC240ServerData(response.data));
                if (!isNull(goToFirstEmptySlotHandler)) {
                    goToFirstEmptySlotHandler();
                }
                if (!isNull(callback)) {
                    callback(response.data);
                }
            }
        })
        .catch(err => {
            console.log(err);
            dispatch(updateC240ServerState(false));
        })
};

export const getScannerState = () => (dispatch) => {
    let url = `/server/scano/1/api~hts~scanner_state/`;
    get_response(url)
        .then(response => {
            if (response.status !== 200) {
                message.error("Error getting scanner state");
            } else {
                dispatch(updateScannerState(response.data.slideLevelState.slideStateMap));
                dispatch(updateQueueState(response.data.scanPreviewQueue));
            }
        })
        .catch(err => {
            console.log(err);
        })
}

export const getStatusOfPersistedState = (callback=null) => (dispatch) => {
    let url = `/server/scano/1/api~hts~get_state_store_status/`;
    get_response(url)
        .then(response => {
            let data = response.data;
            if (data["ScannerState"] == "FAILED_TO_PERSIST_SCANNER_STATUS") {
                message.warn("FAILED_TO_PERSIST_SCANNER_STATUS", 1);
            }
            if (data["TaskQueueState"] == "FAILED_TO_PERSIST_TASK_QUEUE") {
                message.warn("FAILED_TO_PERSIST_TASK_QUEUE", 1);
            }
        })
        .catch(err => {
            console.log(err);
        })
}

export const getMachineStatus = (callback=null) => (dispatch) => {
    let url = `/server/scano/1/api~hts~machine_status/`;
    get_response(url)
        .then(response => {
            if (response.status !== 200) {
                message.error("Error");
            } else {
                let machineStatus = response.data;
                if (machineStatus === "") {
                    machineStatus = {task: "IDLE", subTask: "", progress: "", buffer: "", etaInMs: ""}
                }
                dispatch(updateMachineStatus(machineStatus))
                if (callback !== null) {
                    callback(response.data);
                }
            }
        })
        .catch(err => {
            console.log(err);
        })
}